import { FetchInterceptor } from "@mswjs/interceptors/fetch"

import { env } from "../app/env"
import { getSession, SESSION_HEADER_NAME } from "./session"

interceptProxiedRequests()

export function interceptProxiedRequests() {
  const interceptor = new FetchInterceptor()
  interceptor.apply()
  interceptor.on("request", async ({ request }) => {
    if (!isProxiedRequest(request)) return
    const session = await getSession()
    request.headers.set(SESSION_HEADER_NAME, session.id)
  })
}

function isProxiedRequest(request: Request) {
  const { url } = request

  return (
    url.startsWith(env.PRISMIC_ASSETS_API_BASE_URL.toString()) ||
    url.startsWith(env.PRISMIC_CUSTOM_TYPES_API_BASE_URL.toString()) ||
    (url.startsWith(env.PRISMIC_DEMO_API_BASE_URL.toString()) &&
      new URL(url).pathname !==
        new URL("session", env.PRISMIC_DEMO_API_BASE_URL).pathname) ||
    url.startsWith(env.PRISMIC_DOCUMENT_SEARCH_BASE_URL.toString()) ||
    url.startsWith(env.PRISMIC_USER_SERVICE_BASE_URL.toString()) ||
    url.startsWith(env.PRISMIC_WROOM_BASE_URL.toString())
  )
}
